<!-- Loading Component -->
<app-loading *ngIf="(isLoading$ | async) === true"></app-loading>

<router-outlet></router-outlet>
